module.exports = __webpack_public_path__ + "assets/img/dzh-32.9ddd62a6.png";